import { AttributeModel } from "../main/dynamic/model/attribute.model"

export class SearchParamsModel {
    nome?: string
    policyId?: string = ""
    policyTypeId?: string = ""
    processesIds?: string[]
    status?: string = ""
    unidade?: string = ""
    userId?: string
    currentStepUser?: string
    currentStepUserId?: string
    roles?: string[]
    filter?: string[]
    filterName?: string
    version?: string
    orderDesc?: boolean
    attributes?: AttributeModel[]
    isActive?: boolean

    constructor() {
        this.processesIds = []
        this.attributes = []
    }
}
